var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerritoriesDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.740366 1.1415L0.0415612 15.7336C0.0231197 16.1187 0.42903 16.3789 0.771246 16.2014L5.06359 13.9745C5.22932 13.8886 5.33333 13.7174 5.33333 13.5307V7.81632C5.33333 7.6836 5.3861 7.55632 5.48001 7.46254L12.0238 0.927328C12.3489 0.60269 12.1009 0.0483184 11.6422 0.0743451L1.21147 0.66622C0.955934 0.680719 0.752609 0.885848 0.740366 1.1415Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0657 2.66403L7.02105 8.15194C6.91667 8.24671 6.85714 8.38115 6.85714 8.52213V14.2819C6.85714 14.4361 6.78595 14.5817 6.66422 14.6765L1.99302 18.3116C1.74804 18.5022 1.73417 18.8677 1.964 19.0763L2.04231 19.1474C2.19004 19.2816 2.40338 19.315 2.58507 19.2325L15.6362 13.308C15.8489 13.2114 15.9664 12.9804 15.9192 12.7516L13.8915 2.9331C13.8132 2.55399 13.3523 2.40383 13.0657 2.66403Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerritoriesDisabled);
export default __webpack_public_path__ + "static/media/territoriesDisabled.bea9e940c89c14bcab795e4e17121bce.svg";
export { ForwardRef as ReactComponent };